import { useEffect } from 'react'

import {
  useFilterStateLoader,
  useTableConfigLoader,
} from '../../../../../hooks'
import { getEntityTabFilterStateApi } from '../../../EntityTab.api'
import { ENTITY_TAB_POSTS_FILTER_SUB_MENU } from '../../EntityTabPosts.constants'

import { getEntityTabPostsFilterPermanentFilters } from './useEntityTabPostsFilters.utils'

export function useEntityTabPostsFilters({ filterEntity, scopeId }) {
  const { availableFilters, handleLoadTableConfig } = useTableConfigLoader({
    entity: filterEntity,
  })

  const {
    filterValues,
    handleLoadFilterState,
    handleSetFilterValues,
    hasFilterChanged,
  } = useFilterStateLoader({
    entity: filterEntity,
    filterStateApi: getEntityTabFilterStateApi({
      entityPlural: filterEntity?.plural,
      objectId: scopeId,
      sub: ENTITY_TAB_POSTS_FILTER_SUB_MENU,
    }),
    getPermanentFilters: getEntityTabPostsFilterPermanentFilters,
    sub: ENTITY_TAB_POSTS_FILTER_SUB_MENU,
  })

  useEffect(() => {
    if (filterEntity && scopeId) {
      handleLoadTableConfig()
      handleLoadFilterState()
    }
  }, [filterEntity, scopeId])

  return {
    availableFilters,
    filterValues,
    handleSetFilterValues,
    // null (not loaded) must not read as changed — it hides the empty-state CTA
    hasFilterChanged: filterValues !== null && hasFilterChanged,
  }
}
